// extracted by mini-css-extract-plugin
module.exports = {"button":"PlaceABid_button__1UO3a"};